import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme/darkTheme';

export const LabelsWrapper = styled.div<{ $mt: number; $isThreeLabels?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ $mt }) => $mt}px;
  ${({ $isThreeLabels }) =>
    $isThreeLabels &&
    css`
      gap: 12px;
    `}
`;

export const TrustItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ddefff;
  border-radius: 4px;
  width: calc(50% - 6px);
  padding: 4px;
  font-weight: 700;
  font-size: 10px;
  color: #35b7e1;

  svg {
    ${({ theme }) => css`
      margin-${theme.isRtl ? 'left' : 'right'}: 6px;
    `}
  }

  ${darkMode(css`
    background-color: ${darkPalette.accentSurface};
    border-radius: 8px;
    color: ${darkPalette.accent};

    svg path {
      fill: ${darkPalette.accent};
    }
  `)}
`;
